import { useState } from 'react';
import { record } from "@solimat/solimat-web-endpoint";

const useCreateSolicitudPrestacionesEspeciales = () => {
  const [loadingCreateSolicitudPrestacionesEspeciales, setLoadingCreateSolicitudPrestacionesEspeciales] = useState(false);
  const [successCreateSolicitudPrestacionesEspeciales, setSuccessCreateSolicitudPrestacionesEspeciales] = useState(false);
  const [errorCreateSolicitudPrestacionesEspeciales, setErrorCreateSolicitudPrestacionesEspeciales] = useState(null);
  const [dataCreateSolicitudPrestacionesEspeciales, setDataSolicitudPrestacionesEspeciales] = useState(null);

  const BASE_URL = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_PATH || "";
  const FUNCTIONS_KEY = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_KEY || "";

  const apiRecord = new record.RecordService(
    BASE_URL,
    FUNCTIONS_KEY
  );

  // CREATE
  const createSolicitudPrestacionesEspeciales = async (
    userId: string,
    data: any,
    _cb?: (data: any) => void
  ) => {
    setLoadingCreateSolicitudPrestacionesEspeciales(true);
    setSuccessCreateSolicitudPrestacionesEspeciales(false);
    setErrorCreateSolicitudPrestacionesEspeciales(null);

    apiRecord.newSolicitudComisionPrestacionesEspeciales(userId, data)
      .then((res: any) => {
        setLoadingCreateSolicitudPrestacionesEspeciales(false);
        setSuccessCreateSolicitudPrestacionesEspeciales(true);
        setDataSolicitudPrestacionesEspeciales(res.data);
        _cb?.(res.data);
      })
      .catch((err: any) => {
        console.log(err);
        setLoadingCreateSolicitudPrestacionesEspeciales(false);
        setErrorCreateSolicitudPrestacionesEspeciales(err.response?.data);
      });
  };

  return {
    createSolicitudPrestacionesEspeciales,
    loadingCreateSolicitudPrestacionesEspeciales,
    successCreateSolicitudPrestacionesEspeciales,
    errorCreateSolicitudPrestacionesEspeciales,
    dataCreateSolicitudPrestacionesEspeciales
  };
};

export default useCreateSolicitudPrestacionesEspeciales;
